import React from 'react';
import CafeThemeSchedule from '../CafeThemeSchedule';
import ScheduleV6 from './ScheduleV6';
import { useScheduleV6Gate } from './useScheduleV6Gate';

/**
 * /schedule/themes. The new page only when the gate is open (nav_v6 + the fleet is ready, never for restaurants);
 * otherwise the old page, untouched.
 */
export default function ScheduleThemesRoute() {
  return useScheduleV6Gate() ? <ScheduleV6 /> : <CafeThemeSchedule />;
}
